import API from "@aws-amplify/api";
import { getCurrentJwt } from "../../../../util/jwt/decryptToken"

export async function saveAudience(body) {
  const options = {
    headers: {
      Authorization: getCurrentJwt()
    },
    body: body,
  };

  let sleepTime = 1000
  let res = null
  while (true) {
    try {
      res = await API.put(process.env.REACT_APP_AMPLIFY_API, '/audiences', options).then(data => data)
      return res
    }
    catch (e) {
      console.log(e)
      sleepTime *= 2
      await new Promise(resolve => setTimeout(resolve, sleepTime));
    }
  }
}


// WEBPACK FOOTER //
// ./src/views/AudienceBuilder/util/caching/saveAudience.js